import * as app from './app';
import * as cart from './cart';
import * as checkout from './checkout';
import * as promocode from './promocode';
import * as search from './search';
import * as subscribe from './subscribe';
import * as wishList from './wishList';
import * as navigation from './navigation';
import * as talkToUs from './talkToUs';

export default {
    app,
    cart,
    checkout,
    promocode,
    search,
    subscribe,
    wishList,
    navigation,
    talkToUs,
};
